/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import actionTypes from "../actions";
import jp from "jsonpath";

const initialState = {
  authenticated: false,
  id_token: null,
  userName: null,
  email: null,
  access_token: null,
  userRoles: null,
  userPerms: [],
  modules: JSON.parse(localStorage.getItem("modules")),
  privileges: null,
  tenantId: null,
  tenantData: {},
  providerType: null,
  providerName: null,
  tenantLocale: null,
  userLoginType: null,
  loggedInUserId: null,
  ecommerceCustData: JSON.parse(localStorage.getItem("ecommerceCustData")),
  isCbizAdmin: false,
  loggedInUserName: "",
  menus: [],
  menuPaths: [],
  publicBrowsing: false,
  roles: [],
  enabledModules: {
    INVENTORY: {
      enabled: true,
    },
  },
  tenantInfo: JSON.parse(localStorage.getItem("tenantInfo"))
    ? JSON.parse(localStorage.getItem("tenantInfo"))
    : {},
  genericReports: JSON.parse(localStorage.getItem("genericReports"))
    ? JSON.parse(localStorage.getItem("genericReports"))
    : [],
  priceSummaryView: true,
  quoteEnabled: JSON.parse(localStorage.getItem("modules"))
    ? JSON.parse(localStorage.getItem("modules")).module_quote === "enabled"
    : false,
  apiPermissions: [],
  securityGroupsList: [],
  tenantRoles: [],
  isMenuDrawerOpen: true,
  defaultCountry: "KWT",
  pendingTaskCount: JSON.parse(localStorage.getItem("pendingTaskCount"))
    ? JSON.parse(localStorage.getItem("pendingTaskCount"))
    : 0,
  // sideMenu: JSON.parse(localStorage.getItem('sideMenu')) ? JSON.parse(localStorage.getItem('sideMenu')) : true
  sideMenu:
    localStorage.getItem("sideMenu") !== null
      ? JSON.parse(localStorage.getItem("sideMenu"))
      : true,
  pricePrecision: 2,
  enabledFeatures: {},
};

const permUIMapping = {
  VIEW_CATALOG: ["CUMULATOR_CATALOG_VIEW"],
  BUILD_SOLUTION: ["CUMULATOR_PRODUCT_CREATE"],
  VIEW_ORDERS: ["CUMULATOR_ORDER_VIEW"],
  CREATE_ORDERS: ["CUMULATOR_ORDER_CREATE"],
  ADMIN_ORDERS: ["CUMULATOR_ORDER_ADMIN"],
  VIEW_SUBSCRIPTIONS: ["CUMULATOR_SUBSCRIPTION_VIEW"],
  ADMIN_SUBSCRIPTIONS: ["CUMULATOR_SUBSCRIPTION_ADMIN"],
};

const privTemplate = {
  BUILD_SOLUTION: false,
  VIEW_CATALOG: false,
  VIEW_ORDERS: false,
  CREATE_ORDERS: false,
  ADMIN_ORDERS: false,
  VIEW_SUBSCRIPTIONS: false,
  ADMIN_SUBSCRIPTIONS: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TENANT_INFO: {
      localStorage.setItem("tenantInfo", JSON.stringify(action.data));
      return {
        ...state,
        tenantInfo: action.data,
      };
    }
    case actionTypes.SET_GENERIC_REPORTS: {
      localStorage.setItem("genericReports", JSON.stringify(action.data));
      return {
        ...state,
        genericReports: action.data,
      };
    }
    case actionTypes.UPDATE_USER_NAME_DATA: {
      return {
        ...state,
        loggedInUserName: action.data,
      };
    }
    case actionTypes.AUTHENTICATE: {
      let tempUP = action.profile.userRoles;
      let allPerms = [];
      let loggedInUserId = "";
      let loggedInUserType = "";
      let tenantProviderType = "";
      let tenantProviderName = "";
      let cbizAdmin = false;
      let loggedInUserName = "";
      let menus = [];
      let menuPaths = [];
      let tempRoles = [];
      let apiPermissions = [];
      let tenantRoles = [];
      let securityGroupsList = [];
      let showMyCustomers = true;

      if (tempUP) {
        loggedInUserId = tempUP.data.loggedInUser.userId;
        loggedInUserName = tempUP.data.loggedInUser.userName;
        securityGroupsList = jp.query(tempUP, "$..securityGroup");
        //iterate to get the user login group for the logged in user
        if (JSON.stringify(tempUP.data).includes("PM_ADMIN")) {
        } else {
          for (var i = 0; i < tempUP.data.securityGroups.length; i++) {
            if (
              tempUP.data.securityGroups[i].securityGroup.includes(
                "ECOMMERCE_CUSTOMER",
              ) ||
              tempUP.data.securityGroups[i].securityGroup.includes(
                "ECOMMERCE_ADMIN",
              )
            ) {
              loggedInUserType = tempUP.data.securityGroups[i].securityGroup;
              break;
            }
            if (
              tempUP.data.securityGroups[i].securityGroup.includes(
                "PARTNER_EMPLOYEE",
              ) ||
              tempUP.data.securityGroups[i].securityGroup.includes(
                "PARTNER_ADMIN",
              ) ||
              tempUP.data.securityGroups[i].securityGroup.includes(
                "PARTNER_PRODUCT_MANAGER",
              )
            ) {
              loggedInUserType = tempUP.data.securityGroups[i].securityGroup;
              break;
            }
            if (
              tempUP.data.securityGroups[i].securityGroup.includes(
                "SALES_REPRESENTATIVE",
              )
            ) {
              loggedInUserType = tempUP.data.securityGroups[i].securityGroup;
              break;
            }
            if (
              tempUP.data.securityGroups[i].securityGroup.includes(
                "SALES_MANAGER",
              )
            ) {
              loggedInUserType = tempUP.data.securityGroups[i].securityGroup;
              break;
            }
          }
        }

        let tenantNameList = jp.query(tempUP, "$..tenantName");
        tenantProviderName = tenantNameList[0];
        tenantRoles = jp.query(tempUP, "$..tenantRoles[*]");
        for (let i = 0; i < tenantRoles.length; i++) {
          if (
            tenantRoles[i].includes("_PROVIDER") &&
            (tenantRoles[i] === "SALES_CHNL_PROVIDER" ||
              tenantRoles[i] === "SOLUTION_PROVIDER" ||
              tenantRoles[i] === "SERVICE_PROVIDER")
          ) {
            tenantProviderType = tenantRoles[i];
            break;
          }
        }

        showMyCustomers =
          tenantProviderType === "SALES_CHNL_PROVIDER"
            ? localStorage.getItem("showMyCustomerEnabled") === "true"
            : false;

        let permArr = jp.query(tempUP, "$..permissions");
        for (let i = 0; i < permArr.length; i++) {
          var obj = permArr[i];
          allPerms = [...allPerms, ...obj];
        }
        tempRoles = jp.query(tempUP, "$..roles")[0];
        for (let i = 0; i < securityGroupsList.length; i++) {
          if (securityGroupsList[i] === "CBIZADMIN") {
            cbizAdmin = true;
            break;
          }
        }
        if (
          action &&
          action.profile &&
          action.profile.userRoles &&
          action.profile.userRoles.data &&
          action.profile.userRoles.data.loggedInUser &&
          action.profile.userRoles.data.loggedInUser.menus
        ) {
          menus = action.profile.userRoles.data.loggedInUser.menus;
          menuPaths = [];
          for (var i = 0; i < menus.length; i++) {
            menuPaths.push(menus[i].menuPath);
          }
        }
        if (
          action &&
          action.profile &&
          action.profile.userRoles &&
          action.profile.userRoles.data &&
          action.profile.userRoles.data.loggedInUser &&
          action.profile.userRoles.data.loggedInUser.apis
        ) {
          apiPermissions = action.profile.userRoles.data.loggedInUser.apis;
        }
      }
      let tempPerms = allPerms;
      let tempPermMapping = permUIMapping;
      if (tempPerms) {
        if (tempPermMapping.VIEW_CATALOG.some((r) => tempPerms.includes(r))) {
          privTemplate.VIEW_CATALOG = true;
        }
        if (tempPermMapping.BUILD_SOLUTION.some((r) => tempPerms.includes(r))) {
          privTemplate.BUILD_SOLUTION = true;
        }
        if (tempPermMapping.VIEW_ORDERS.some((r) => tempPerms.includes(r))) {
          privTemplate.VIEW_ORDERS = true;
        }
        if (tempPermMapping.CREATE_ORDERS.some((r) => tempPerms.includes(r))) {
          privTemplate.CREATE_ORDERS = true;
        }
        if (tempPermMapping.ADMIN_ORDERS.some((r) => tempPerms.includes(r))) {
          privTemplate.ADMIN_ORDERS = true;
        }
        if (
          tempPermMapping.VIEW_SUBSCRIPTIONS.some((r) => tempPerms.includes(r))
        ) {
          privTemplate.VIEW_SUBSCRIPTIONS = true;
        }
        if (
          tempPermMapping.ADMIN_SUBSCRIPTIONS.some((r) => tempPerms.includes(r))
        ) {
          privTemplate.ADMIN_SUBSCRIPTIONS = true;
        }
      }

      return {
        ...state,
        authenticated: true,
        id_token: action.profile.id_token,
        userName: action.profile.profile.name,
        access_token: action.profile.access_token,
        email: action.profile.profile.preferred_username,
        userPerms: [...allPerms],
        privileges: { ...privTemplate },
        providerType: tenantProviderType,
        providerName: tenantProviderName,
        userLoginType: loggedInUserType,
        loggedInUserId: loggedInUserId,
        isCbizAdmin: cbizAdmin,
        loggedInUserName,
        menus,
        menuPaths,
        roles: tempRoles,
        apiPermissions,
        securityGroupsList,
        tenantRoles,
        showMyCustomers,
      };
    }
    case actionTypes.REFRESH_USER_TOKEN: {
      let tempAccessToken = action.accessToken;
      return {
        ...state,
        authenticated: true,
        access_token: tempAccessToken,
      };
    }
    case actionTypes.SET_TENANT_ID: {
      return {
        ...state,
        tenantId: action.id,
      };
    }
    case actionTypes.SET_TENANT_DATA: {
      return {
        ...state,
        tenantData: action.data,
      };
    }
    case actionTypes.SET_TENANT_LOCALE: {
      return {
        ...state,
        tenantLocale: action.locale,
      };
    }
    case actionTypes.ECOMMERCE_CUST_DATA: {
      localStorage.setItem("ecommerceCustData", JSON.stringify(action.data));
      return {
        ...state,
        ecommerceCustData: action.data,
      };
    }
    case actionTypes.SET_PUBLIC_BROWSING: {
      localStorage.setItem("publicBrowsing", JSON.stringify(action.data));
      return {
        ...state,
        publicBrowsing: action.data,
      };
    }
    case actionTypes.SET_ENABLED_MODULES: {
      return {
        ...state,
        enabledModules: action.data,
      };
    }
    case actionTypes.SET_MENU_DRAWER_OPEN: {
      return {
        ...state,
        isMenuDrawerOpen: action.data,
      };
    }
    case actionTypes.SET_PENDING_TASK_COUNT: {
      localStorage.setItem("pendingTaskCount", action.data);
      return {
        ...state,
        pendingTaskCount: action.data,
      };
    }
    case actionTypes.SET_MODULES: {
      return {
        ...state,
        modules: action.data,
        quoteEnabled: action.data.module_quote === "enabled",
      };
    }
    case actionTypes.SET_SIDE_MENU: {
      localStorage.setItem("sideMenu", JSON.stringify(action.data));
      return {
        ...state,
        sideMenu: action.data,
      };
    }
    case actionTypes.SET_PRICE_PRECISION: {
      return {
        ...state,
        pricePrecision: action.data,
      };
    }
    case actionTypes.SET_DEFAULT_COUNTRY: {
      return {
        ...state,
        defaultCountry: action.data,
      };
    }
    case actionTypes.SET_ENABLED_FEATURES: {
      return {
        ...state,
        enabledFeatures: action.data,
      };
    }
    case "LOGOUT":
      return {
        authenticated: false,
        id_token: null,
        userName: null,
        email: null,
        access_token: null,
        userRoles: null,
        userPerms: [],
        tenantId: null,
        tenantData: {},
        providerType: null,
        providerName: null,
        tenantLocale: null,
        userLoginType: null,
        loggedInUserId: null,
        isCbizAdmin: false,
        loggedInUserName: "",
        menus: [],
        menuPaths: [],
        publicBrowsing: false,
        roles: [],
        tenantInfo: {},
        apiPermissions: [],
        securityGroupsList: [],
        tenantRoles: [],
        enabledFeatures: {},
      };
    default:
      return state;
  }
};

export default reducer;
